export default "__VITE_ASSET__KWzSJz8$__"